module.exports = __webpack_public_path__ + "static/qr.toutiao-7f6f854fd3573ceaec2085c0d49bb38f.jpeg";